import { TeamScoringOption } from './TeamScoringOption';
import type { TeamScoringQuestionProps } from '@/utils/scoring/adapters/teamScoringAdapter';
import type { MatchStatsResponse } from '@/api/feed/getFeedMatchStats';

interface TeamScoringQuestionComponentProps extends TeamScoringQuestionProps {
  questionId: string;
  fixtureId?: string;
  onMarkCorrect?: (optionId: string, isCorrect: boolean) => void;
  onSave?: (optionId: string) => void;
  onCancel?: (optionId: string) => void;
  language?: 'en' | 'fr';
  manualScoring?: boolean;
  matchStats?: MatchStatsResponse;
  onStatChange?: (optionId: string, statValue: number) => void;
  onOverrideSuccess?: () => void;
}

export function TeamScoringQuestion({
  questionId,
  fixtureId,
  options,
  statTypeCode,
  onSave,
  onCancel,
  language = 'en',
  manualScoring = false,
  matchStats,
  onStatChange,
  onOverrideSuccess,
}: TeamScoringQuestionComponentProps) {
  return (
    <div className="space-y-3">
      {/* Options - Side by Side Layout */}
      <div className="flex gap-4">
        {options.map((option, index) => (
          <TeamScoringOption
            key={option.option_id || index}
            questionId={questionId}
            fixtureId={fixtureId}
            option={option}
            statTypeCode={statTypeCode}
            language={language}
            manualScoring={manualScoring}
            matchStats={matchStats}
            onStatChange={onStatChange}
            onSave={onSave}
            onCancel={onCancel}
            onOverrideSuccess={onOverrideSuccess}
          />
        ))}
      </div>
    </div>
  );
}
